import type BookingData from '@/model/common/BookingData';

type BookingDataPayload = BookingData['data'] | null;

export function resolveTravelType(data: BookingDataPayload) {
    if (!data) return null;
    return data.frontendParams?.cruise ? 'cruise' : data.travelType;
}
